import { Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { Account, CustomerSlip, User } from 'service';
import { RootState } from 'store/store';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import ArthaGateway from 'service/ArthaGateway';
import AsyncSelect from 'react-select/async';
import { useSelector } from 'react-redux';
import Swal from "sweetalert2";

export const TransactionDetails = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [user, setUser] = useState<User>();
    const [account, setAccount] = useState<Account | null>(null);
    const [transactions, setTransactions] = useState<any[]>([]);
    const [fromDate, setFromDate] = useState<string>(moment().subtract(1, 'year').startOf('month').format('YYYY-MM-DD'));
    const [toDate, setToDate] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'));
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!account) {
            setTransactions([]);
            return;
        }
        loadCustomerTransactions();
    }, [account, fromDate, toDate]);

    const loadCustomerTransactions = () => {
        if (!account) return;
        setIsLoading(true);
        ArthaGateway.getTransactions(fromDate, toDate, account.id, 0, 1, 1000).then((data) => {
            if (data && data.entries) {
                setTransactions(data.entries);
            } else {
                setTransactions([]);
            }
            setIsLoading(false);
        });
    }

    const onSearchAccount = async (inputValue: string) => {
        if (inputValue.length < 3) {
            return [];
        }
        try {
            const response = await ArthaGateway.getAccounts(inputValue);
            return response.entries.map((account: Account) => ({
                value: account,
                label: account.name
            }));
        } catch (error) {
            console.error("Error in onSearchAccount:", error);
            return [];
        }
    }

    return (
        <div className="container py-2">
            <div className="row mb-1">
                <div className="col-12">
                    <h2>Customer Ledger</h2>
                </div>
            </div>
            <div className="row mb-1">
                <div className="col-md-6">
                    <AsyncSelect
                        cacheOptions
                        onChange={(selectedOption) => {
                            setAccount(selectedOption ? selectedOption.value : null);
                        }}
                        loadOptions={onSearchAccount}
                        value={account ? { value: account, label: account.name } : null}
                        isClearable
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        placeholder="Select cutomer"
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-6 col-md-3">
                    <label className="form-label">From</label>
                    <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>
                <div className="col-6 col-md-3">
                    <label className="form-label">To</label>
                    <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>
            </div>
            {!account && (
                <div className="alert alert-secondary text-center p-2" role="alert">
                    Please select a customer to view the ledger.
                </div>
            )}

            {account && (
                <>
                    <hr />
                    {transactions.length === 0 && (
                        <div className="alert alert-warning text-center p-2" role="alert">
                            No transactions found for this customer for the given period.
                        </div>
                    )}

                    <div className="card shadow-sm">
                        <div className="card-body p-0">
                            <ul className="list-group shadow-sm">
                                {transactions.map((transaction, idx) => (
                                    <li
                                        key={transaction.transactionId}
                                        className="list-group-item border-0 border-bottom px-3 py-2"
                                    >
                                        {/* Top Row: Date + Site */}
                                        <div className="d-flex justify-content-between">
                                            <small className="text-muted">
                                                {new Date(transaction.transactionDate).toLocaleDateString()}
                                            </small>
                                            <small className="text-muted">{transaction.siteName}</small>
                                        </div>

                                        {/* Description */}
                                        <div className="fw-semibold text-truncate">{transaction.description}</div>

                                        {/* Amount Row */}
                                        <div className="d-flex justify-content-between mt-1">
                                            <div>
                                                {transaction.debit > 0 && (
                                                    <span className="text-success fw-semibold">Dr ₹{transaction.debit.toLocaleString()}</span>
                                                )}
                                                {transaction.credit > 0 && (
                                                    <span className="text-danger fw-semibold">Cr ₹{transaction.credit.toLocaleString()}</span>
                                                )}
                                            </div>
                                            <div>
                                                <small className="text-muted">
                                                    Closing: <span className="fw-semibold">₹{transaction.closingBalance.toLocaleString()}</span>
                                                </small>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};